// jQuery(document).ready(function($) {
//     if (is_dev) {
//         view_invoice_product(34,0,'');
//     }
// });

/**
 * Look for the last reveal, it should be a popup containing the new quotation / invoice wizard with a client_id in it
 * It also logs, cuz jQuery tends to hang looking up the last reveal
 *
 * @returns {*}
 */
function look_for_new_client_id() {
    const $ = jQuery.noConflict();
    // const last_reveal = $('.reveal:visible:last');
    const last_reveal_with_a_client_id_in_it = $('.reveal:visible:has(input[name="client_id"]):last')
    // console.log(last_reveal.html());
    return last_reveal_with_a_client_id_in_it.find('input[name="client_id"]').val();
}

/**
 * Look for the objects' date in the opened screens
 *
 * @returns {*}
 */
function look_for_object_date(object) {
    const $ = jQuery.noConflict();

    let found = null;
    $(`.reveal:visible input[name="${object}_date"]`).each(function() {
        found = $(this);
    });
    if (found !== null) {
        return found.val();
    }
    const d = new Date();
    return d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear();
}

/**
 * Loads the product selector for adding products to a paperwork object
 *
 * @param elm
 * @param ajaxObj
 */
function paperwork_load_product_selector(elm, ajaxObj) {
    const $ = jQuery.noConflict();
    elm.find('[data-product-selector]').productSelector().change(function() {
        const w = $(this).parents('.repeat-item:first');
        const v = $(this).val();
        if(!w.is(':visible')) {
            look_for_product_and_do_the_following(v, function(product) {
                if (product) {
                    elm.find('.delivered-field-wrapper').toggle(parseInt(product.has_to_be_delivered) === 1);
                }
            });
            return;
        }

        look_for_product_and_do_the_following(v, function(product) {
            if (product) {
                const is_original_price = product['is_original_price'] === undefined || product['is_original_price'] === true;
                w.find('.show-if-price-is-not-original').toggle(!is_original_price);
                if (!is_original_price) {
                    w.find('.original-price').html($.number(product['original_price'], 2, ",", "."));
                }

                w.find(':input[name*="name\\]"]').prev().find('iframe').contents().find('body').html('<span>'+product.name+'</span>');

                w.find(':input[name*="price\\]"]').val(product.price);
                w.find(':input[name*="discount\\]"]').val(product.discount);
                if (product.discount > 0) {
                    w.find(':input[name*="discount_type\\]"]').val('percentage');
                }
                if(product.taxes_included === 0) {
                    w.find(':input.taxes-included').removeAttr('checked');
                } else {
                    w.find(':input.taxes-included').attr('checked', 'checked');
                }


                const taxInput = w.find(':input[name*="tax\\]"]');
                if (product.tax_type_id) {
                    taxInput.val(taxInput.find('option[data-tax-type="' + product.tax_type_id + '"]:first').val());
                } else {
                    taxInput.val(product.tax_id);
                }

                update_product_price(w);
            }
        }, ajaxObj)
    });
}

/**
 * Loads the screen for adding products to this paperwork model
 *
 * @param object
 * @param id
 * @param client_id
 */
function paperwork_add_products(object, id, client_id) {
    var $ = jQuery.noConflict();

    if(id == undefined) {
        id = "new";
    }
    if(client_id == undefined || client_id == '') {
        client_id = look_for_new_client_id();
    }

    $.squdeAjaxPopup({
        url: '/administration/'+object+'/add_products/'+id,
        data: {
            client_id: client_id,
            date: look_for_object_date(object)
        },
        onOpen: function(elm, popup) {
            var fn = object+'_load_product_selector(elm)';
            eval(fn);

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                if(id == 'new') {
                    popup.close();
                    $('.'+object+'-products-table').reloadThisElement();
                } else {
                    reload_location_if_needed();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
}

/**
 * View + edit an existing paperwork-product
 *
 * @param object
 * @param id
 * @param new_object
 * @param client_id
 */
function view_paperwork_product(object, id, new_object, client_id) {
    var $ = jQuery.noConflict();

    if(new_object == undefined) {
        new_object = 0;
    }
    if(client_id == undefined) {
        client_id = look_for_new_client_id();
    }

    var data = {};
    data['client_id'] = client_id;
    data['new_'+object] = new_object;



    $.squdeAjaxPopup({
        url: '/administration/'+object+'/view_single_product/'+id,
        data: data,
        onOpen: function(elm, popup) {
            var fn = object+'_load_product_selector(elm)';
            eval(fn);
            update_product_price(elm.find(':input[name*="name\\]"]'));

            propose_to_update_all_other_products_on_price_change(elm);

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();
                if(new_object == 1) {
                    popup.close();
                    $('.'+object+'-products-table').reloadThisElement();
                } else {
                    reload_location_if_needed();
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
}

function propose_to_update_all_other_products_on_price_change(elm) {
    const $ = jQuery.noConflict();

    const originalIn = elm.find('#amount_in').val();
    const originalEx = elm.find('#amount_ex').val();
    const inputSelector = elm.find('label[for="price"] :input, label[for="discount"] :input, label[for="tax"] :input');

    const form = $('<form></form>');
    form.append(inputSelector.clone(true,true));
    const originalData = form.serializeJSON();
    form.remove();



    inputSelector.bind('change keyup', function() {
        const form = $('<form></form>');
        elm.find('select').each(function() {
            const v = $(this).val();
            $(this).find('option').removeAttr('selected');
            $(this).find('option[value="' + v + '"]').attr('selected', 'selected');
            $(this).val(v);
        });
        form.append(inputSelector.clone(true,true));
        const newData = form.serializeJSON();
        form.remove();

        const show = JSON.stringify(originalData) !== JSON.stringify(newData) &&
            originalIn !== elm.find('#amount_in').val() &&
            originalEx !== elm.find('#amount_ex').val();
        elm.find('.mass-update-product-wrapper').toggle(show);

        if (!show) {
            elm.find('#change_same_products').removeAttr('checked');
        }
    })
}

/**
 *
 * Load the preview for this paperwork item
 *
 * @param elm
 * @param type
 */
function load_paperwork_preview(elm, last_form, type) {
    const $ = jQuery.noConflict();
    const url = '/administration/' + type + '/preview';
    const iframe_container = elm.find('iframe.preview').parent();

    const target_uid = get_unique_id();
    const iframe_elm = document.createElement('iframe');
    iframe_elm.setAttribute('frameborder', 0);
    iframe_elm.setAttribute('class', 'preview');
    iframe_elm.id = target_uid;
    iframe_elm.name = target_uid;

    iframe_container.html($(iframe_elm));

    const target_iframe = iframe_container.find('iframe');
    target_iframe.contents().find("body").html('');

    const uid = get_unique_id();

    const load_preview = function(layout) {
        $('body').append('<form action="'+url+'" method="post" target="'+target_uid+'" id="'+uid+'"></form>');
        var temp_form = $('form#'+uid);
        last_form.find(':input').each(function() {
            var name = $(this).attr('name');
            var type = $(this).attr('type');
            if(name !== undefined && type !== 'submit' && name !== "_token" && (type !== "checkbox" || (type === "checkbox" && $(this).is(':checked')))) {
                var v = $(this).val().replace(/"/g, "'");;
                temp_form.append('<input type="hidden" name="'+$(this).attr('name')+'" value="'+v+'" class="generated-input" />');
            }
        });
        if(layout === undefined) {
            layout = 0;
        }
        temp_form.append('<input type="hidden" name="print_layout_id" value="'+layout+'" class="generated-input" />');
        temp_form.submit().remove();



        target_iframe.parent().parent().isLoading();
        var check_if_done_loading_preview = setInterval(function() {
            var html = target_iframe.contents().find('body').html();
            if(html !== undefined && html.length > 0) {
                target_iframe.parent().parent().doneLoading();
                clearInterval(check_if_done_loading_preview);
            }
        }.bind([target_iframe]),10);
    }.bind([elm, url, target_uid, uid, target_iframe]);
    elm.find('select#layout').unbind('change').bind('change', function() {
        var v = $(this).val();
        elm.find('.generated-input[name="'+$(this).attr('name')+'"]').val(v);
        var src = target_iframe.attr('src');
        target_iframe.attr('src', 'about:blank');

        setTimeout(function() {
            target_iframe.attr('src', src);
            load_preview(v);
        },100);
    }).trigger('change');
}

/**
 * Delete a given paperwork object
 *
 * @param type
 * @param id
 * @param identifier
 * @param close
 * @returns {boolean}
 */
function delete_paperwork_object(type, id, identifier, close = false) {
    const $ = jQuery.noConflict();
    identifier = decodeURI(identifier);
    confirm('Weet u zeker dat u \'' + identifier + '\' wilt verwijderen?', function() {
        $('body').isLoading('dark');
        $.ajax({
            url: '/administration/' + type + '/delete',
            data: {id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'' + type + '\'][data-id=\'' + id + '\']').remove();
                let wait = 0;
                if (close === true) {
                    wait = 300;
                    let foundRevealOverlay;
                    $('.reveal-overlay:visible').each(function() {
                        foundRevealOverlay = $(this);
                    });
                    if (foundRevealOverlay) {
                        foundRevealOverlay.find('.reveal').foundation('close');
                    }
                }
                squde_reload_for_flashes();
                setTimeout(function() {
                    reload_location_if_needed(false);
                }, wait);

                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}

function copy_paperwork(type, id) {
    const $ = jQuery.noConflict();
    $('body').isLoading();
    $.ajax({
        url: '/administration/' + type + '/copy',
        data: {id},
        type: "POST",
        success: function(newObject) {
            $('body').doneLoading();


            reload_location_if_needed(false, () => {
                const fn = 'view_' + type + '(' + newObject.id + ')';
                eval(fn);
            });
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}
